import Layout, { PageHeader } from "../components/Layout";

const SECTIONS = [
  ["Information we collect", "Name, date of birth, gender, contact details, country/city, timezone and the reason for consultation you provide while booking. Payment is processed by Razorpay; we do not store card or bank details."],
  ["How we use it", "Solely to schedule and conduct your consultation, send confirmations and video links, and maintain medical records as required by the Telemedicine Practice Guidelines (India)."],
  ["Medical reports", "Reports you share over WhatsApp are used only by Dr. Porwal and clinic staff for your care. They are never shared with third parties without your consent."],
  ["Data protection", "We follow the principles of India's Digital Personal Data Protection Act, 2023: purpose limitation, data minimisation, and reasonable security safeguards."],
  ["Your rights", "You may request access to, correction of, or deletion of your personal data by contacting us."],
  ["Contact", "For privacy questions, write to dr.porwal@porwaloncology.in."],
];

export const LegalBody = ({ sections }) => (
  <section className="max-w-3xl mx-auto px-4 sm:px-8 py-14 space-y-10">
    {sections.map(([h, p]) => (
      <div key={h}><h2 className="text-xl font-serif text-slate-900">{h}</h2><p className="mt-3 text-slate-700 leading-relaxed">{p}</p></div>
    ))}
  </section>
);

export default function Privacy() {
  return (
    <Layout>
      <PageHeader eyebrow="Legal" title="Privacy Policy" subtitle="Your health information is personal. Here is how we look after it." />
      <LegalBody sections={SECTIONS} />
    </Layout>
  );
}
